var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-section"},[_c('div',{staticClass:"step-header"},[_c('div',{staticClass:"step-name"},[_vm._t("name")],2),_c('div',{staticClass:"step-description"},[_vm._t("description")],2)]),_vm._t("custom-controls",function(){return [_c('div',{staticClass:"step-controls"},[_vm._t("controls")],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }